import { render, staticRenderFns } from "./gallery-cross-fading-images.vue?vue&type=template&id=4c49b8f2&scoped=true&"
import script from "./gallery-cross-fading-images.ts?vue&type=script&lang=ts&"
export * from "./gallery-cross-fading-images.ts?vue&type=script&lang=ts&"
import style0 from "./gallery-cross-fading-images.scss?vue&type=style&index=0&id=4c49b8f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49b8f2",
  null
  
)

export default component.exports